export default __webpack_public_path__ + "static/media/profile.453fd679.png";